import React from 'react';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import { useAppSelector } from '../../../../hooks/hooks';
import { selectListItems } from '../../../../redux/library/selector';
import GlobalDbnSubscriptionMemberBasicInfoComponent from './global-pack-subscription-basic-info';


export const GlobalDbnSubscriptionMemberComponent = ({ 
  setFunctionAttributes, 
  functionAttributes, 
  id, entityAttributes, 
  setEntityAttributes, 
  parentDomain, 
  handleInnerFormChange, 
  selectedDomain, 
  GlobalDbnRoutingPacksData,
  // handleFormItemChange,
   mediaFiles, 
   changeImage, 
   templateFiles,
   back, 
   handleFormTemplateItemChange,
   handleImageChange,
   globalDBNPRegistrationsItems,
   handleFormSubmit 
  }: any) => {
      const libraryData = useAppSelector(selectListItems)

  const tabItems = [
    {
      id: 1,
      title: 'Basic Information',
      component: <GlobalDbnSubscriptionMemberBasicInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        GlobalDbnRoutingPacksData={GlobalDbnRoutingPacksData}
        globalDBNPRegistrationsItems={globalDBNPRegistrationsItems}
        selectedDomain={selectedDomain}
        parentDomain={parentDomain}
      />,
      isVisible: true,
    },
     
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">


      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}
export default GlobalDbnSubscriptionMemberComponent;
